import React from 'react'
import Intercom from 'react-intercom'

export class IntercomComponent extends React.Component {
  render() {
    return (
      <div className='app'>
        <Intercom
          appID='vsffcg6p'
          hide_default_launcher={false}
        />
      </div>
    )
  }
}
